import { OidcClient, UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { AuthProviderProps } from 'react-oidc-context';
import { Environment } from '@src/environment';
import { Paths } from '@src/routes/paths';

// oidc-client-ts stores the session in sessionStorage by default, which means a
// session is scoped to a single tab and is lost when that tab closes. Use
// localStorage so the session survives a reload and is shared across tabs.
const stores =
  typeof window !== 'undefined'
    ? {
        userStore: new WebStorageStateStore({ store: window.localStorage }),
        stateStore: new WebStorageStateStore({ store: window.localStorage }),
      }
    : {};

export const oidcConfig = {
  authority: Environment.OIDC_AUTHORITY,
  client_id: Environment.OIDC_CLIENT_ID,
  redirect_uri: `${Environment.PUBLIC_URL}${Paths.CALLBACK}`,
  // signinSilent() only uses the refresh token when one is available and falls
  // back to a hidden iframe otherwise. Without this setting that fallback
  // throws "No silent_redirect_uri configured" instead of renewing.
  silent_redirect_uri: `${Environment.PUBLIC_URL}${Paths.SILENT_CALLBACK}`,
  scope: 'openid profile email',
  ...stores,
} satisfies AuthProviderProps;

// One UserManager for the whole app. <AuthProvider> in main.tsx is handed this
// instance rather than the plain config: given a config it would build a second
// UserManager with its own silent-renew timer writing to the same storage key,
// so the two would renew independently and overwrite each other's session.
export const userManager = new UserManager(oidcConfig);

export const oidcClient = new OidcClient(oidcConfig);
